var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.data),expression:"data"}],staticClass:"fct-textarea",staticStyle:{"text-align":"right"},attrs:{"rows":10},domProps:{"value":(_vm.data)},on:{"input":function($event){if($event.target.composing)return;_vm.data=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }